import BaseAPI from './base-api-client.js'
import { fetchResponseHandler } from './error-utils.js'

export default class ProfileAPI extends BaseAPI {
    static async show (request) {
        try {
            const response = await this.fetchSecure('/user/profile', {
                method: 'GET',
            })

            return await fetchResponseHandler(response)
        } catch (error) {
            console.error('ProfileAPI.show - Error:', error)
            throw error
        }
    }

    static async update (request) {
        try {
            const response = await this.fetchSecure('/user/profile', {
                body: request,
                method: 'PATCH',
            })

            return await fetchResponseHandler(response)
        } catch (error) {
            throw error
        }
    }

    static async updateAvatar (request) {
        try {
            const response = await this.fetchSecure('/user/profile', {
                body: request,
                headers: {},
                method: 'PATCH',
                multipart: true,
            })

            return await fetchResponseHandler(response)
        } catch (error) {
            throw error
        }
    }

    static async store (request) {}


    static async showLimited (profile_id) {
        try {
            const response = await this.fetch(`/user/profile/${profile_id}`, {
                method: 'GET',
            })

            return await fetchResponseHandler(response)
        } catch (error) {
            console.error('ProfileAPI.showLimited - Error:', error)
            throw error
        }
    }

    static async showByReferralCode (referralCode) {
        try {
            const response = await this.fetch(`/user/profile/referral/${referralCode}`, {
                method: 'GET',
            })

            return await fetchResponseHandler(response)
        } catch (error) {
            throw error
        }
    }


    static async getReferralSummary () {
        try {
            const response = await this.fetchSecure('/user/profile/referral/summary', {
                method: 'GET',
            })

            return await fetchResponseHandler(response)
        } catch (error) {
            throw error
        }
    }

    static async submitReferralFeedback (request) {
        const response = await this.fetchSecure('/user/profile/referral/feedback', {
            body: request,
            method: 'POST',
        })

        return await fetchResponseHandler(response)
    }

    /**
     * TENANT-5570 — a US host asks the commercial team for help with a sales tax ID.
     * `POST /user/profile/tax-id-request`, no body; the api emails commercial and stamps
     * `tax_ids.us_requested_at` on the profile.
     */
    static async requestTaxIdAssistance () {
        const response = await this.fetchSecure('/user/profile/tax-id-request', {
            method: 'POST',
        })

        return await fetchResponseHandler(response)
    }

    static async getMyReviews () {
        const response = await this.fetchSecure('/user/profile/review', {
            method: 'GET',
        })

        return await fetchResponseHandler(response)
    }

    static async getReviews (profile_id) {
        const response = await this.fetchSecure(`/user/profile/${profile_id}/review`, {
            method: 'GET',
        })

        return await fetchResponseHandler(response)
    }
}